import type { ReactElement } from 'react';
import { useGamesSite } from '../context';
import type { GameCard } from '../types';

/**
 * Play: opens the game. A game that needs an account sends a signed-out
 * visitor through sign-in first and back to the game — the app's route does
 * that, so the link is the same for everyone and only the words change.
 */
export function PlayButton({
  game,
  size = 'pill',
}: {
  game: Pick<GameCard, 'title' | 'launchPath' | 'requiresSignIn'>;
  size?: 'pill' | 'large';
}): ReactElement {
  const { Link, signedIn } = useGamesSite();
  const signInFirst = game.requiresSignIn && !signedIn;
  const label = size === 'large' && signInFirst ? 'Sign in to play' : 'Play';
  return (
    <Link
      href={game.launchPath}
      className={`fg-play fg-play--${size}`}
      aria-label={signInFirst ? `Sign in to play ${game.title}` : `Play ${game.title}`}
    >
      {label}
    </Link>
  );
}
